// eslint react/jsx-filename-extension : ignore

import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  ExpansionPanel,
  ExpansionPanelSummary,
  Typography,
  ExpansionPanelDetails
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { svgIconStyle, StyledButton, TextButton } from '../../../theme/Global'

const industryDefinitions = [
  {
    key: 0,
    name: 'hospitality',
    title: 'Hospitality',
    content:
      'The hospitality industry includes restaurants and hotels. A restaurant includes any eating or drinking place that prepares and offers food or beverage either on any of its premises or by such service as catering, banquet, box lunch, curb service or counter service. A hotel is any establishment which offers lodging accommodations to the public, to employees, or to members.'
  },
  {
    key: 1,
    name: 'buildingServices',
    title: 'Building Services',
    content:
      'The building service industry includes any person, corporation or establishment engaged in whole or in part in renting, servicing, cleaning, maintaining, selling, or managing buildings or building space, and all occupations, operations and services in connection therewith or incidental thereto. The industry includes, but is not limited to, real estate owners, building owners, operators, lessors, managing agents and independent contractors.'
  },
  {
    key: 2,
    name: 'standard',
    title: 'Standard',
    content:
      'The standard industry includes all industries other than hospitality, building service, farm, or not for profit establishments (that have chosen to be exempt from minimum wage coverage). For example: car washes, construction contractors, transportation companies, retail or healthcare establishments would be included in the Miscellaneous Industries.'
  }
]

class IndustryDefinitionComponent extends React.Component {
  state = {
    open: false,
    expanded: null
  }

  handleClickOpen = () => {
    this.setState({ open: true })
  }

  handleChange = (panel) => (event, expanded) => {
    this.setState({ expanded: expanded ? panel : false })
  }

  handleClose = () => {
    this.setState({ open: false })
  }

  render() {
    const { expanded } = this.state

    return (
      <React.Fragment>
        <TextButton
          color="primary"
          disableRipple
          onClick={this.handleClickOpen}
          style={{ float: 'right' }}
        >
          Industry Definitions
        </TextButton>
        <Dialog
          maxWidth="sm"
          fullWidth={false}
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">Industry Definitions</DialogTitle>
          <DialogContent>
            <DialogContentText
              style={{ borderTop: '1px solid #e4e4e4' }}
            >
              {industryDefinitions.map((industry, idx) => (
                <ExpansionPanel
                  key={industry.key}
                  expanded={expanded === `panel${idx}`}
                  onChange={this.handleChange(`panel${idx}`)}
                >
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon style={svgIconStyle()} />}>
                    <Typography>{industry.title}</Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <Typography>{industry.content}</Typography>
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              ))}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <StyledButton variant="raised" color="secondary" onClick={this.handleClose} color="primary">
              Close
            </StyledButton>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    )
  }
}

export default IndustryDefinitionComponent
